import { render } from "./ThankYou.vue?vue&type=template&id=862b8504"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"
script.render = render

export default script